import { HERO_IMAGES } from "@/lib/constants";

export default function Story() {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative bg-[#FDFBF7] py-24 md:py-36 overflow-hidden grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12 items-start">
          <div className="col-span-12 md:col-span-5 md:sticky md:top-32">
            <p className="font-mono-accent text-[12px] text-[#7A2021] mb-6">
              — Chapter One
            </p>
            <h2
              data-testid="story-heading"
              className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[#1A1713]"
            >
              A kitchen <br /> with a memory.
            </h2>
          </div>

          <div className="col-span-12 md:col-span-7 space-y-7 text-[#1A1713]/85 text-base md:text-lg leading-relaxed">
            <p>
              Ladiosa's was born from grandmothers — three of them, on three
              continents. From a Soul kitchen in the American South, a Spanish
              abuela's cazuela, and a Mediterranean nonna's olive-oil-stained
              apron. We cook the way they taught us: slow, generous, a little
              loud.
            </p>
            <p>
              In Houston we found our table. A brasserie of our own — banquettes
              in deep oxblood, brass that catches the late afternoon, and a bar
              that doesn't close before the conversation does. We borrow the
              posture of Paris and the warmth of Texas, and we serve everything
              family-style.
            </p>
            <p>
              The menu is wide — sandwiches Angelina would approve of, short ribs
              with miso and maple, cilantro-lime wings, and the kind of brunch
              you book on a Tuesday because Sunday already feels too late. There
              is champagne. There is butter. There is, frankly, no minimalism.
            </p>

            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-[#E4DECD] mt-10">
              <div>
                <p className="font-serif-display text-4xl text-[#7A2021]">3</p>
                <p className="font-mono-accent text-[12px] text-[#5C5449] mt-2">
                  Cuisines
                </p>
              </div>
              <div>
                <p className="font-serif-display text-4xl text-[#7A2021]">160+</p>
                <p className="font-mono-accent text-[12px] text-[#5C5449] mt-2">
                  House Dishes
                </p>
              </div>
              <div>
                <p className="font-serif-display text-4xl text-[#7A2021]">1</p>
                <p className="font-mono-accent text-[12px] text-[#5C5449] mt-2">
                  Long Table
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Image strip */}
        <div className="grid grid-cols-12 gap-4 md:gap-6 mt-24">
          <div className="col-span-12 md:col-span-7 aspect-[16/10] overflow-hidden">
            <img
              src={HERO_IMAGES.interior}
              alt="Ladiosa's brasserie interior"
              className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-1000"
            />
          </div>
          <div className="col-span-12 md:col-span-5 aspect-[4/5] overflow-hidden">
            <img
              src={HERO_IMAGES.brunch}
              alt="Brunch at Ladiosa's"
              className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-1000"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
